import * as stylex from '@stylexjs/stylex';
import { styles } from './skeleton.styles';
interface SkeletonProps {
  /** Any CSS length; defaults to the full width of the container. */
  width?: string;
  /** Any CSS length; defaults to one line of body text. */
  height?: string;
  circle?: boolean;
}

/** A placeholder block standing in for content that is still loading — it holds
 *  the content's shape so the layout does not jump when the data lands.
 *
 *  Decorative on its own (`aria-hidden`): the CONTAINER it sits in says it is busy
 *  (`aria-busy`, or a `Spinner`'s status role), because a screen reader has nothing
 *  useful to say about fifteen grey bars. */
export function Skeleton({
  width = '100%',
  height = '12px',
  circle = false
}: SkeletonProps) {
  return <span aria-hidden="true" {...stylex.props(styles.base, circle && styles.circle)} style={{
    width,
    height
  }} />;
}